import Loadable from '@townsquare/loadable';
import { chatRoute } from '@townsquare/routes/chat';
import { createAgentRoute } from '@townsquare/routes/create-agent';
import { editAgentRoute } from '@townsquare/routes/edit-agent';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';

const ChatLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "chat-view" */ './components/ChatView/index'),
  loading: () => null,
});
chatRoute.component = ChatLoadable;
chatRoute.resources = [rovoEntitlementResource];
export const chatRouterRoute = chatRoute;

const CreateAgentLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "create-agent-view" */ './components/CreateAgentView/index'),
  loading: () => null,
});
createAgentRoute.component = CreateAgentLoadable;
createAgentRoute.resources = [rovoEntitlementResource];
export const createAgentRouterRoute = createAgentRoute;

const EditAgentLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "edit-agent-view" */ './components/EditAgentView/index'),
  loading: () => null,
});
editAgentRoute.component = EditAgentLoadable;
editAgentRoute.resources = [rovoEntitlementResource];
export const editAgentRouterRoute = editAgentRoute;

export const isInRovoFullscreenPages = (routeName: string) =>
  routeName === chatRoute.name || routeName === createAgentRoute.name || routeName === editAgentRoute.name;
